/**
 * Unified notifications inbox types.
 *
 * The inbox merges two durable sources into one time-ordered feed:
 *  1. `notification` rows (DMs, friend requests, replies, and explicit
 *     `@user` Space mentions — which are bounded and fanned out on write).
 *  2. `space_mention` items projected at read time from Space message markers
 *     for group mentions (`@here` / a role the member holds). These are NOT
 *     stored per-recipient, so they scale to very large communities.
 *
 * Items are ordered by their `id` (an ObjectId hex, which is chronological), so
 * the same opaque cursor pages both sources without duplication.
 */
/** Largest bell "new" count the server computes; UI renders `N+` at the cap. */
export const INBOX_UNSEEN_COUNT_CAP = 99;
/** Default inbox page size. */
export const INBOX_PAGE_SIZE = 30;
//# sourceMappingURL=inbox-types.js.map